import { render, staticRenderFns } from "./screen-form.vue?vue&type=template&id=362108dd&scoped=true"
import script from "./screen-form.vue?vue&type=script&lang=js"
export * from "./screen-form.vue?vue&type=script&lang=js"
import style0 from "./screen-form.vue?vue&type=style&index=0&id=362108dd&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362108dd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('362108dd')) {
      api.createRecord('362108dd', component.options)
    } else {
      api.reload('362108dd', component.options)
    }
    module.hot.accept("./screen-form.vue?vue&type=template&id=362108dd&scoped=true", function () {
      api.rerender('362108dd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/line/components/screen-form.vue"
export default component.exports